import { actionTypes } from "./EmailTemplateActions";
import { SortTypes } from "../../../../util/table-view/TableTypes";
import { defaultResultsPerPage, pagingTotalRelation } from "../../../../redux/Types";

const initialState = {
  editing: null,
  posting: { busy: false, message: "", errors: null },
  items: [],
  totalItems: 0,
  totalRelation: pagingTotalRelation.EQUALS,
  selectedItem: {},
  selectedItems: [],
  loading: false,
  query: {
    inPage: "all",
    order: SortTypes.desc,
    orderBy: "updatedAt",
    page: 0,
    size: defaultResultsPerPage,
    q: "",
    filters: [],
  },
  errors: null,
  history: {}
};

export default function (state = initialState, action) {
  switch (action.type) {
    case actionTypes.LOADING:
      return {
        ...state,
        loading: true,
        errors: null,
        selectedItems: [],
        items: [],
      };

    case actionTypes.LOAD:
      return {
        ...state,
        loading: false,
        errors: null,
        items: action.payload,
        totalItems: action.total,
        totalRelation: action.totalRelation,
        selectedItem: action.payload[0] || {},
        errors: null,
        selectedItems: [],
      };

    
    case actionTypes.ERROR:
      return {
        ...state,
        loading: false,
        errors: action.payload,
        items: [],
        totalItems: 0,
        totalRelation: pagingTotalRelation.EQUALS,
      };

    
    case actionTypes.QUERY:
      return {
        ...state,
        query: action.payload,
      };

    case actionTypes.SELECT_ITEMS:
      return {
        ...state,
        selectedItems: action.payload,
      };

    case actionTypes.FOCUS_ITEM:
      return {
        ...state,
        selectedItem: action.payload,
      };

    case actionTypes.EDIT_ITEM:
      return {
        ...state,
        editing: action.payload,
      };

    case actionTypes.REFRESH_ITEMS:
      return {
        ...state,
        items: action.payload,
      };

      
    case actionTypes.POST_ERROR:
      return {
        ...state,
        posting: {
          busy: false,
          message: "",
          errors: action.payload,
        },
      };

    case actionTypes.POSTING:
      return {
        ...state,
        posting: {
          busy: true,
          message: action.payload,
          errors: null,
        },
      };

      
    case actionTypes.POST_OK:
      return {
        ...state,
        posting: {
          busy: false,
          message: "",
          errors: null,
        },
      };


    case actionTypes.CLEAR_ERRORS:
      return {
        ...state,
        posting: {
          busy: false,
          message: "",
          errors: null,
        },
      };  

    case actionTypes.LOAD_HISTORY:
      state.history[action.payload.emailId] = action.payload.history
      return {
        ...state
      };

    case actionTypes.REMOVE_HISTORY:
      action.payload.forEach(function(id) {
        delete state.history[id];
      });
      return {
        ...state
      };

    default:
      return state;
  }
}
